export const visit = (vm, at) => {
at({ "lt": { "conversationsVisitorUIAvailability": { "sameDay": "Gr\u012F\u0161ime \u0161iandien {{time}}", "nextDay": "Gr\u012F\u0161ime rytoj {{time}}", "nextWeek": "Gr\u012F\u0161ime: {{dayOfWeek}} {{time}}" } } });
};